/*eslint react-hooks/exhaustive-deps: "off"*/

import Axios from 'axios';
import { Dropdown } from 'primereact/dropdown';
import React, { useCallback, useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import useProcessRules from 'src/hooks/useProcessRules';
import useQueryString from 'src/hooks/useQueryString';
import { URL_PLUGIN } from 'src/parametros';
import useInputsResources from 'src/reducers/InputsResources/useInputsResources';
import validator from 'validator';
import CustomErrorMessage from './CustomErrorMessage';
import InputLabel from './InputLabel';

const CustomSelect = ({ name, inputs, setInputs, ...input }) => {
  const [codCore] = useState(input.longitud);
  const [codDepente, setCodDepente] = useState(null);
  const [codDepente2, setCodDepente2] = useState(null);
  const [url, setUrl] = useState('');
  const [options, setOptions] = useState([]);
  const qparams = useQueryString();
  const location = useLocation();
  const [isCallback, setIsCallback] = useState(false);

  // Establece los datos para el combo en formato -- {value: 'codCore|valor', nombre: 'valor'}
  const procesarOpcions = (options) => {
    if (options instanceof Array) {
      const newOptions = options
        .map((value) => {
          let valueCmb = `${value.codigo}`;
          // let valueCmb = `${value.codigo}`;
          let nombre = validator.isNumeric(`${value.valor}`) ? parseFloat(value.valor) : value.valor;
          let valor2 = { ...value }
          delete valor2['codigo'];
          if (!!`${value.codCore}` && (`${value.codCore}` !== 'undefined')) {
            // valueCmb = `${value.codCore}`;
            valueCmb = `${value.codCore}`;
            nombre = value.nombre;
            delete valor2['codCore'];
          }
          delete valor2['nombre'];
          return { value: valueCmb, nombre, ...valor2 };
        })
        .sort((a, b) => {
          if (a.nombre < b.nombre) return -1;
          if (a.nombre > b.nombre) return 1;
          return 0;
        });

      const defaultValue = options?.find((item) => item?.default === 'true');
      if (defaultValue && !methods.getValues(name)) {
        methods.setValue(name, `${defaultValue?.codigo}`);
        // methods.setValue(name, `${defaultValue?.codigo}|${defaultValue?.valor}`);
      }
      return newOptions;
    }
    return [];
  };

  const { state } = useInputsResources();

  const methods = useFormContext();
  const { watch, control, setValue } = methods;

  const { processValidations, setLoading } = useProcessRules(input);

  const { cotizacion }: any = useSelector<any>((state) => state.Cotizacion);
  const { broker } = cotizacion;

  const getData = useCallback(async () => {
    setLoading(true);
    const { data } = await Axios.get(
      //`${URL_PLUGIN}listar-desplegables&empCodigo=libelula&codCore=${input.longitud}`,
      `${URL_PLUGIN}listar-desplegables&empCodigo=${broker}&codCore=${codCore}`,
    );

    const { nivel, url, data: opciones, codCoreDepend } = data;
    switch (nivel) {
      case '1':
        if (opciones && opciones.length > 0) {
          setOptions(procesarOpcions(opciones));
        } else if (url && url !== '') {
          const { data: res } = await Axios.get(url);
          if (res.transaccion && res.data.length > 0) {
            setOptions(procesarOpcions(res.data));
          }
        }
        break;

      case '2':
        const item = inputs.find(({ longitud }) => longitud === codCoreDepend);
        console.log("SELECT:", item, inputs, codCoreDepend)
        setCodDepente(item.codCore);
        setUrl(url);
        const valueDepend = watch(item.codCore);
        if (valueDepend && valueDepend !== '' && typeof valueDepend !== 'object') {
          const keyValue = valueDepend.split('|');
          if (keyValue) {
            await getDataLeve2(keyValue, url).then(opcion => {
              // debugger
              setOptions(procesarOpcions(opcion))
            });
          }
        }
        break;

      case '3':
        // codCoreDepend.forEach(element => {
        // });


        const item1 = inputs.find(({ longitud }) => longitud === codCoreDepend[0]);
        const item2 = inputs.find(({ longitud }) => longitud === codCoreDepend[1]);

        setCodDepente(item1.codCore);
        setCodDepente2(item2.codCore);
        setUrl(url);
        const valueDepend1 = watch(item1.codCore);
        const valueDepend2 = watch(item2.codCore);
        if ((valueDepend1 && valueDepend1 !== '' && typeof valueDepend1 !== 'object') && (valueDepend2 && valueDepend2 !== '' && typeof valueDepend2 !== 'object')) {
          const keyValue1 = valueDepend1.split('|');
          const keyValue2 = valueDepend2.split('|');
          if (keyValue1 && keyValue2) {
            await getDataLeve3(keyValue1, keyValue2, url).then(opcion =>
              setOptions(procesarOpcions(opcion))
            );
          }
        }
        break;

      default:
        setIsCallback(true);
        break;
    }
    setLoading(false);
  }, []);

  const dependiente = watch(codDepente);
  const dependiente2 = watch(codDepente2);

  useEffect(() => {

    if (state.hasOwnProperty(name)) {
      setOptions?.(procesarOpcions(state?.[name]));
    }
  }, [state]);

  useEffect(() => {
    getData();
  }, []);

  // Ontiene los datos del select cuando depende de un valor de otro campo select
  const getDataLeve2 = async ([codCore, nombre], url) => {
    setLoading(true);
    if (url && url !== '') {
      // envia al servicio el id del select dependiente
      let newUrl = url.replace('{{valor}}', codCore).replace('&marCodigoCore', '');
      const { data: res } = await Axios.get(newUrl);
      if (res.transaccion) {
        if (res.data) {
          setLoading(false);
          return res.data;
        } else {
          // envia al servicio el nombre del select dependiente
          let newUrl = url.replace('{{valor}}', nombre).replace('&marCodigoCore', '');
          const { data: res } = await Axios.get(newUrl);
          if (res.transaccion) {
            setLoading(false);
            return res.data;
          }
          setLoading(false);
          return [];
        }
      } else {
        // envia al servicio el nombre del select dependiente
        let newUrl = url.replace('{{valor}}', nombre).replace('&marCodigoCore', '');
        const { data: res } = await Axios.get(newUrl);
        if (res.transaccion) {
          setLoading(false);
          return res.data;
        }
        setLoading(false);
        return [];
      }
    } else {
      setLoading(false);
      return [];
    }
  };

  // Ontiene los datos del select cuando depende de un valor de dos campos Select
  const getDataLeve3 = async (value1, value2, url) => {
    setLoading(true);
    if (url && url !== '') {
      // envia al servicio el id del select dependiente
      let newUrl = url.replace('{{valor}}', value1[0]).replace('{{valor1}}', value2[0]).replace('&marCodigoCore', '');
      const { data: res } = await Axios.get(newUrl);

      if (res.transaccion) {
        if (res.data) {
          setLoading(false);
          return res.data;
        } else {
          // envia al servicio el nombre del select dependiente
          let newUrl = url.replace('{{valor}}', value1[0]).replace('{{valor1}}', value2[0]).replace('&marCodigoCore', '');
          const { data: res } = await Axios.get(newUrl);
          if (res.transaccion) {
            setLoading(false);
            return res.data;
          }
          setLoading(false);
          return [];
        }
      } else {
        let newUrl = url.replace('{{valor}}', value1[0]).replace('{{valor1}}', value2[0]).replace('&marCodigoCore', '');
        const { data: res } = await Axios.get(newUrl);
        if (res.transaccion) {
          setLoading(false);
          return res.data;
        }
        setLoading(false);
        return [];
      }
    } else {
      setLoading(false);
      return [];
    }
  };

  const cargarValorSiExiste = () => {
    const path = location.pathname.split('/')[1];
    if(path == 'newPaginaCompra') {
      console.log('xxxxxxxxxxx Es pagina titular ' );
      if(qparams.index) {
        if(cotizacion.beneficiarios && cotizacion.beneficiarios[qparams.index]) {
          setTimeout(() => {
            setValue(name, cotizacion.beneficiarios[qparams.index][name]);
          },1000)
        }
      }else {
        if(cotizacion.beneficiarios) {
          setTimeout(() => {
            setValue(name, cotizacion.beneficiarios[0][name]);
          },1000)
        }
      }
    }else if(path == 'newRegistro') {
      console.log('Es pagina titular ' );
      if(cotizacion.titular && typeof cotizacion.titular == 'object') {
        setTimeout(() => {
          setValue(name, cotizacion.titular[name]);
        },1000)
      }
    }
  }

  const validarDefaultValue = () => {
    const value = watch(name);
    if (value !== undefined && typeof value !== 'object') {
      const keys = value.split('|')[0];
      if (!keys[0]) {
        setValue(name, '');
      }
    }
  };

  useEffect(() => {
    if (isCallback) {
      return;
    }

    if (dependiente && typeof dependiente !== 'object' && url && url !== '') {
      const keyValue = dependiente.split('|');
      if (keyValue) {
        setValue(name, '');
        // debugger
        getDataLeve2(keyValue, url).then((options2) => {
          // debugger
          setOptions(procesarOpcions(options2));
        });
      }
    } else {
      //setOptions([]);
      //setValue(name, "")
    }
  }, [dependiente]);

  useEffect(() => {
    if (isCallback) {
      return;
    }

    if ((dependiente && typeof dependiente !== 'object' && url && url !== '') && (dependiente2 && typeof dependiente2 !== 'object' && url && url !== '')) {
      const keyValue1 = dependiente.split('|');
      const keyValue2 = dependiente2.split('|');
      if (keyValue1 && keyValue2) {
        setValue(name, '');
        getDataLeve3(keyValue1, keyValue2, url).then((options) => {
          setOptions(procesarOpcions(options));
        });
      }
    } else {
      //setOptions([]);
      //setValue(name, "")
    }
  }, [dependiente, dependiente2]);


  useEffect(() => {
    validarDefaultValue();
    cargarValorSiExiste();
  }, []);

  const rules = processValidations();
  if (input.codCore === 'modelo')
    console.log('input SELECT', { input, name });

  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        // desabled={input?.editable}
        // defaultValue={''}
        render={({ field: { onChange, value, ...rest } }) => {
          return (
            <>
              {/* {options.length > 10 && ( */}
              <span className="p-float-label">
                <Dropdown
                  {...rest}
                  value={value ? value.split('|')[0] : value}
                  options={options}
                  // label={input?.campo}
                  editable={input?.editable}
                  disabled={input?.disabled}
                  required={rules.hasOwnProperty('required')}
                  dataKey="value"
                  // value={value || ''}
                  optionLabel="nombre"
                  optionValue="value"
                  filterBy="nombre"
                  filter={options.length > 10}

                  onChange={(evt) => {
                    const valor = options.find(item => item?.value === evt?.value)
                    onChange(`${evt?.value}|${valor.nombre}`);
                  }}
                />
                <InputLabel input={input} rules={rules} />
              </span>
              {/* )}

              {options.length < 11 && (
                <span className="p-float-label">
                  <Dropdown
                    editable={input?.editable}
                    filter={options.length > 10}
                    filterInputAutoFocus={false}
                    //id={input.id + ''}
                    dataKey="value"
                    optionLabel="nombre"
                    optionValue="value"
                    options={options}
                    filterBy="nombre"
                    //autoWidth
                    filterPlaceholder="Escriba aquí para buscar"
                    emptyFilterMessage="Sin resultados"
                    resetFilterOnHide
                    className={classnames({
                      'w-100': true,
                      'p-invalid': !!errors[name],
                    })}
                    disabled={loading}
                    onChange={(event) => {
                      //verifyInputTypeFromSelect(name,inputs,setInputs,event.value,);
                      console.log(event.value);
                      onChange(event.value);
                    }}
                    value={value}
                    placeholder={loading ? 'CARGANDO...' : ''}
                  />

                  <InputLabel input={input} rules={rules} />
                </span>
              )} */}
            </>
          );
        }}
      />
      <CustomErrorMessage name={name} />
    </>
  );
};

export default CustomSelect;
